import { UserActivityType } from 'apis/auditLogs';

/**
 * Human-readable labels for the user (contact) audit-log event types. Keyed by
 * every event declared in {@link UserActivityType} so the mapping stays
 * exhaustive - adding a new event type there is a compile error until it is
 * given a label here.
 */
export const userEventTypeLabels: Record<UserActivityType, string> = {
  COMMERCE_ORDER_CREATED: 'Order created',
  COMMERCE_ORDER_DRAFTED: 'Order drafted',
  COMMERCE_ORDER_CANCELED: 'Order canceled',
  COMMERCE_REFUND_CREATED: 'Refund created',
  COMMERCE_ORDER_FULFILLED: 'Order fulfilled',
  COMMERCE_ORDER_DELIVERED: 'Order delivered',
  COMMERCE_DELIVERY_ATTEMPT_FAILED: 'Delivery attempt failed',
  COMMERCE_RETURN_REQUESTED: 'Return requested',
  COMMERCE_RETURN_RECEIVED: 'Return received',
  CONVERSATION_CREATED: 'Conversation started',
  CONVERSATION_ASSIGNED: 'Conversation assigned',
  CONTACT_MERGED_INTO: 'Merged into another contact',
  CONTACT_MERGED_FROM: 'Contacts merged in',
  USER_BANNED: 'Banned',
  USER_UNBANNED: 'Unbanned',
  AGENT_BANNED_USER: 'Banned a contact',
  AGENT_UNBANNED_USER: 'Unbanned a contact',
  USER_UPDATED: 'Updated',
  USER_ADDED: 'Added',
  USER_CUSTOM_ATTRIBUTES_UPDATED: 'Custom attributes updated',
  AGENT_PRESENCE_STATUS_CHANGED: 'Presence status changed',
  AGENT_OFFLINE: 'Offline',
  AGENT_ONLINE: 'Online',
};
